import { Application } from '@hotwired/stimulus';

import AddressController from './address_controller';
import AdminAssignmentsController from './admin/assignments_controller';
import AdminBulkController from './admin/bulk_controller';
import AdminColumnsController from './admin/columns_controller';
import AdminCommentsController from './admin/comments_controller';
import AdminCsvController from './admin/csv_controller';
import AdminDashboardController from './admin/dashboard_controller';
import AdminExportController from './admin/export_controller';
import AdminFocusController from './admin/focus_controller';
import AdminGroupsController from './admin/groups_controller';
import AdminMessagesController from './admin/messages_controller';
import AdminMissionController from './admin/mission_controller';
import AdminPactsController from './admin/pacts_controller';
import AdminPagyController from './admin/pagy_controller';
import AdminReassignController from './admin/reassign_controller';
import AdminSettingsController from './admin/settings_controller';
import AdminSettingsGroupController from './admin/settings_group_controller';
import AdminSortableController from './admin/sortable_controller';
import AdminTableController from './admin/table_controller';
import AdminUserStatusController from './admin/user_status_controller';
import AdminUsersListController from './admin/users_list_controller';
import AnnouncementController from './announcement_controller';
import AutoScrollController from './auto_scroll_controller';
import CharactersCounterController from './characters_counter_controller';
import CheckboxSelectAllController from './checkbox_select_all_controller';
import CleaveController from './cleave_controller';
import CloseAlertController from './close_alert_controller';
import CollapseController from './collapse_controller';
import CountdownController from './countdown_controller';
import DropdownController from './dropdown_controller';
import FavoritesController from './favorites_controller';
import FileUploadController from './file_upload_controller';
import FlatpickrController from './flatpickr_controller';
import HighlightController from './highlight_controller';
import IframeLoaderController from './iframe_loader_controller';
import MapboxController from './mapbox_controller';
import MissionFormController from './mission_form_controller';
import ModalsDefaultController from './modals/default_controller';
import ModalsMissionController from './modals/mission_controller';
import ModalsSelectionController from './modals/selection_controller';
import NavController from './nav_controller';
import OrganizationController from './organization_controller';
import PhoneController from './phone_controller';
import RevealController from './reveal_controller';
import ScrollController from './scroll_controller';
import SelectionController from './selection_controller';
import SlimSelectController from './slim_select_controller';
import SortableController from './sortable_controller';
import SwalController from './swal_controller';
import SweetalertController from './sweetalert_controller';
import SwitchController from './switch_controller';
import TippyController from './tippy_controller';
import ToastController from './toast_controller';

const application = Application.start();

application.register('address', AddressController);
application.register('admin--assignments', AdminAssignmentsController);
application.register('admin--bulk', AdminBulkController);
application.register('admin--columns', AdminColumnsController);
application.register('admin--comments', AdminCommentsController);
application.register('admin--csv', AdminCsvController);
application.register('admin--dashboard', AdminDashboardController);
application.register('admin--export', AdminExportController);
application.register('admin--focus', AdminFocusController);
application.register('admin--groups', AdminGroupsController);
application.register('admin--messages', AdminMessagesController);
application.register('admin--mission', AdminMissionController);
application.register('admin--pacts', AdminPactsController);
application.register('admin--pagy', AdminPagyController);
application.register('admin--reassign', AdminReassignController);
application.register('admin--settings', AdminSettingsController);
application.register('admin--settings-group', AdminSettingsGroupController);
application.register('admin--sortable', AdminSortableController);
application.register('admin--table', AdminTableController);
application.register('admin--user-status', AdminUserStatusController);
application.register('admin--users-list', AdminUsersListController);
application.register('announcement', AnnouncementController);
application.register('auto-scroll', AutoScrollController);
application.register('characters-counter', CharactersCounterController);
application.register('checkbox-select-all', CheckboxSelectAllController);
application.register('cleave', CleaveController);
application.register('close-alert', CloseAlertController);
application.register('collapse', CollapseController);
application.register('countdown', CountdownController);
application.register('dropdown', DropdownController);
application.register('favorites', FavoritesController);
application.register('file-upload', FileUploadController);
application.register('flatpickr', FlatpickrController);
application.register('highlight', HighlightController);
application.register('iframe-loader', IframeLoaderController);
application.register('mapbox', MapboxController);
application.register('mission-form', MissionFormController);
application.register('modals--default', ModalsDefaultController);
application.register('modals--mission', ModalsMissionController);
application.register('modals--selection', ModalsSelectionController);
application.register('nav', NavController);
application.register('organization', OrganizationController);
application.register('phone', PhoneController);
application.register('reveal', RevealController);
application.register('scroll', ScrollController);
application.register('selection', SelectionController);
application.register('slim-select', SlimSelectController);
application.register('sortable', SortableController);
application.register('swal', SwalController);
application.register('sweetalert', SweetalertController);
application.register('switch', SwitchController);
application.register('tippy', TippyController);
application.register('toast', ToastController);

window.Stimulus = application;

export { application };
